/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CommentReadWatermarkRequest,
  CommentReadWatermarkResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Comments<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags comment-read-watermark-controller
   * @name GetWatermark
   * @summary Read the caller's read watermark for a comment scope
   * @request GET:/comments/read
   * @secure
   * @response `200` `CommentReadWatermarkResponse` OK
   */
  getWatermark = (
    query: {
      /** Which kind of resource `resourceId` names. See the table above. */
      scopeType: "ORDER" | "MEDIA_PLAN" | "TASK" | "ATTACHMENT";
      /** The scoped resource id — for `ATTACHMENT`, the attachment's OWNING PARENT (booking id or task id), not the attachment id. */
      resourceId: string;
      /** The attachment id. Required for `scopeType=ATTACHMENT`; omit for every other scope. */
      subresourceId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<CommentReadWatermarkResponse, any>({
      path: `/comments/read`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags comment-read-watermark-controller
   * @name MarkRead
   * @summary Stamp the caller's read watermark for a comment scope
   * @request PATCH:/comments/read
   * @secure
   * @response `200` `CommentReadWatermarkResponse` OK
   */
  markRead = (data: CommentReadWatermarkRequest, params: RequestParams = {}) =>
    this.request<CommentReadWatermarkResponse, any>({
      path: `/comments/read`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
